// Angular imports
import {
	Component,
	ElementRef,
	OnDestroy,
	OnInit,
	Renderer2,
	ViewChild,
} from "@angular/core";
import { Title } from "@angular/platform-browser";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import {
	Observable,
	Subject,
	forkJoin,
	map,
	of,
	startWith,
	takeUntil,
} from "rxjs";

// Models
import { ContextLocationViewModel } from "src/app/_core/models/main/context-location.model";
import { LinkItem } from "src/app/_core/models/main/link-item.model";
import { Policies } from "src/app/_core/models/main/policies.enum";
import { getHomeMenu } from "src/app/_core/constants/menu.constants";

// Services
import {
	FormBuilder,
	FormControl,
	FormGroup,
	Validators,
} from "@angular/forms";
import { MatTabGroup } from "@angular/material/tabs";
import { TranslateService } from "@ngx-translate/core";
import { CebeProcedureViewModel } from "src/app/_core/models/centros/cebe-procedure.model";
import { CebeViewModel } from "src/app/_core/models/centros/cebe.model";
import { CebesCentrosViewModel } from "src/app/_core/models/centros/centro-list-base.model";
import { CentrosViewModel } from "src/app/_core/models/centros/centro.model";
import { EmpleadoViewModel } from "src/app/_core/models/centros/empleado.model";
import { IdCodigoDescripcion } from "src/app/_core/models/centros/idCodigoDescripcion.model";
import { AuthService } from "src/app/_core/providers/auth.service";
import { CebesCentrosService } from "src/app/_core/providers/cebes-centros.service";
import { CebesService } from "src/app/_core/providers/cebes.service";
import { CentrosService } from "src/app/_core/providers/centros.service";
import {
	GlobalService,
	MigaDePan,
} from "src/app/_core/providers/global.service";
import { ImportService } from "src/app/_core/providers/import.service";
import { MasterService } from "src/app/_core/providers/master.service";
import { NotificationService } from "src/app/_core/providers/notification.service";
import { UserProfileStore } from "src/app/_core/stores/user-profile.store";
import { CentroDesignDataCardComponent } from "../../components/centros/centro-design-data-card/centro-design-data-card.component";
import { CentroDetailsCardComponent } from "../../components/centros/centro-details-card/centro-details-card.component";
import { CentroOperationDataCardComponent } from "../../components/centros/centro-operation-data-card/centro-operation-data-card.component";
import { CentroUserReportCardComponent } from "../../components/centros/centro-user-report-card/centro-user-report-card.component";

@Component({
	selector: "app-centro-page",
	templateUrl: "./centro.page.html",
	styleUrls: ["./centro.page.scss"],
})
export class CentroPageComponent implements OnInit, OnDestroy {
	// Properties
	@ViewChild("CentroDetailsCardComponentRef")
	centroDetailsComponent: CentroDetailsCardComponent;
	@ViewChild("CentroUserReportCardComponentRef")
	centroUserReportComponent: CentroUserReportCardComponent;
	@ViewChild("CentroDesignDataCardComponentRef")
	centroDesignDataComponent: CentroDesignDataCardComponent;
	@ViewChild("CentroOperationDataCardComponentRef")
	centroOperationDataComponent: CentroOperationDataCardComponent;
	@ViewChild("tabGroup") tabGroup: MatTabGroup;
	@ViewChild("fileInputUsers") fileInput: any;

	responsableControl: FormControl = new FormControl([Validators.required]);
	responsableReporteControl: FormControl = new FormControl();
	introductorAmbientalControl: FormControl = new FormControl();
	introductorSocialControl: FormControl = new FormControl();
	validadorPrincipalControl: FormControl = new FormControl();
	validadorApoyoControl: FormControl = new FormControl();
	cebeControl: FormControl = new FormControl();
	mainFormGroup: FormGroup;

	public cebesCentros: CebeProcedureViewModel[] = [];
	public cebe: CebeProcedureViewModel;
	cebesSimples: IdCodigoDescripcion[] = [];

	public employees: EmpleadoViewModel[] = [];
	employeesfilterResponsable: Observable<EmpleadoViewModel[]>;
	employeesfilterReporte: Observable<EmpleadoViewModel[]>;
	employeesfilterAmbiental: Observable<EmpleadoViewModel[]>;
	employeesfilterSocial: Observable<EmpleadoViewModel[]>;
	employeesfilterValPrincipal: Observable<EmpleadoViewModel[]>;
	employeesfilterValApoyo: Observable<EmpleadoViewModel[]>;

	private selectedFilesUsers: File | null = null;
	public centro: CentrosViewModel;
	public cebeCentro: CebesCentrosViewModel;
	public isCreating: boolean = false;

	lastTabIndex: number;
	validatedCentroDetailsForm: boolean;
	validatedUsuariosReportForm: boolean = false;
	validatedDesignForm: boolean;
	validatedOperationForm: boolean;
	centroOperationData: FormGroup;
	centroReportData: FormGroup;
	centroDesignData: FormGroup;
	centroDetailData: FormGroup;

	public fotophotoEmReporte: string | ArrayBuffer = "/assets/images/user.png";
	public fotophotoEmAmbiental: string | ArrayBuffer =
		"/assets/images/user.png";
	public fotophotoEmSocial: string | ArrayBuffer = "/assets/images/user.png";
	public fotophotoEmValPrincipal: string | ArrayBuffer =
		"/assets/images/user.png";
	public fotophotoEmValApoyo: string | ArrayBuffer =
		"/assets/images/user.png";
	public fotophotoResponsable: string | ArrayBuffer =
		"/assets/images/user.png";

	public cebeId: number = 0;
	public cebePadre: CebeViewModel;
	public cebesimple: IdCodigoDescripcion;
	// Attributes
	private readonly destroy$ = new Subject<void>();
	contextLocation: ContextLocationViewModel;

	private readonly menu: LinkItem[] = getHomeMenu();
	constructor(
		private readonly _titleService: Title,
		private readonly _translateService: TranslateService,
		private readonly _route: ActivatedRoute,
		private readonly _centrosService: CentrosService,
		private readonly _cebesService: CebesService,
		private readonly _masterService: MasterService,
		private readonly _cebesCentrosService: CebesCentrosService,
		private readonly userProfileStore: UserProfileStore,
		private readonly _authService: AuthService,
		private readonly router: Router,
		private readonly fb: FormBuilder,
		private readonly _importService: ImportService,
		private readonly renderer: Renderer2,
		private readonly _notificationService: NotificationService,
		private readonly _globalService: GlobalService,
	) {}

	// Events
	ngOnInit(): void {
		this._globalService.setHeaderOptions(
			[],
			this.contextLocation,
			[],
			this.menu,
		);

		this.router.events.subscribe((event) => {
			if (event instanceof NavigationEnd) {
			}
		});

		this._route.params
			.pipe(takeUntil(this.destroy$))
			.subscribe((params) => {
				this._titleService.setTitle(
					this._translateService.instant("title.centro.home"),
				);

				this.cebeId = Number(
					this._route.snapshot.paramMap.get("cebeId"),
				);
				const centroId = Number(
					this._route.snapshot.paramMap.get("centroId"),
				);

				this.contextLocation = {
					centro: this._route.snapshot.params["centroId"],
				};

				forkJoin({
					employees: this._masterService.getEmpleados(),
					centro: centroId
						? this._centrosService.getCentroById(centroId)
						: of(null),

					cebeCentro: centroId
						? this._cebesCentrosService.getContratoCentroByCentro(
								centroId,
							)
						: of(null),

					cebe:
						this.cebeId !== 0
							? this._cebesService.getCebeById(this.cebeId)
							: of(null),
				})
					.pipe(takeUntil(this.destroy$))
					.subscribe(({ employees, centro, cebeCentro, cebe }) => {
						this.employees = employees;
						this.cebeCentro = cebeCentro;

						if (cebe) {
							this.cebePadre = cebe;

							this.cebesimple = {
								id: cebe.id,
								codigo: cebe.codigo,
								descripcion: cebe.descripcion,
							};
							this.cebesSimples.push(this.cebesimple);
							const partes = window.location.href
								.split("/")
								.filter((p) => p !== "");

							const miga: MigaDePan = {
								nombre: `(${this.cebePadre?.codigo}) ${this.cebePadre?.descripcion}`,
								url: `${partes[0]}//${partes[1]}/#/cebe/${this.cebePadre?.id}`,
							};

							this._globalService.agregarCebeToMiga(miga);
						} else {
							this._cebesService
								.getCebeById(cebeCentro.contratoID)
								.subscribe((s) => {
									this.cebePadre = s;

									this.cebesimple = {
										id: s.id,
										codigo: s.codigo,
										descripcion: s.descripcion,
									};

									this.cebesSimples.push(this.cebesimple);
									// this.loadCebesCentro();
									const partes = window.location.href
										.split("/")
										.filter((p) => p !== "");

									const miga: MigaDePan = {
										nombre: `(${this.cebePadre?.codigo}) ${this.cebePadre?.descripcion}`,
										url: `${partes[0]}//${partes[1]}/#/cebe/${this.cebePadre?.id}`,
									};

									this._globalService.agregarCebeToMiga(miga);
									const miga1: MigaDePan = {
										nombre: `(${centro?.codigo}) ${centro?.descripcion}`,
										url: window.location.href,
									};

									this._globalService.agregarCentroToMiga(
										miga1,
									);
								});
						}
						if (centro) {
							this.centro = centro;

							this.mainFormGroup = this.initMainFormGroup();
						} else {
							this.isCreating = true;
							this.initCreateMode();
						}

						this.loadCebesCentro();
					});

				this.employeesfilterResponsable =
					this.responsableControl.valueChanges.pipe(
						startWith(""),
						map((value) => this._filterEmResponsable(value)),
					);

				this.employeesfilterReporte =
					this.responsableReporteControl.valueChanges.pipe(
						startWith(""),
						map((value) => this._filterEmReporte(value)),
					);

				this.employeesfilterAmbiental =
					this.introductorAmbientalControl.valueChanges.pipe(
						startWith(""),
						map((value) => this._filterEmAmbiental(value)),
					);

				this.employeesfilterSocial =
					this.introductorSocialControl.valueChanges.pipe(
						startWith(""),
						map((value) => this._filterEmSocial(value)),
					);

				this.employeesfilterValPrincipal =
					this.validadorPrincipalControl.valueChanges.pipe(
						startWith(""),
						map((value) => this._filterValPrincipal(value)),
					);

				this.employeesfilterValApoyo =
					this.validadorApoyoControl.valueChanges.pipe(
						startWith(""),
						map((value) => this._filterValApoyo(value)),
					);
			});
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	async loadValues(
		fotophotoEmReporte: string | ArrayBuffer,
		fotophotoEmAmbiental: string | ArrayBuffer,
		fotophotoEmSocial: string | ArrayBuffer,
		fotophotoEmValPrincipal: string | ArrayBuffer,
		fotophotoEmValApoyo: string | ArrayBuffer,
	): Promise<void> {
		if (!this.isCreating) {
			let ruta: string | ArrayBuffer;
			const empleadoResponsable: EmpleadoViewModel = this.employees.find(
				(f) => f.id == this.centro.responsableID,
			);
			this.responsableControl.setValue(empleadoResponsable);
			ruta = this.getPhoto2(
				empleadoResponsable?.email,
				this.fotophotoResponsable,
			);

			const empleadoReporte: EmpleadoViewModel = this.employees.find(
				(f) => f.id == this.centro.responsableReporteID,
			);
			this.responsableReporteControl.setValue(empleadoReporte);
			ruta = this.getPhoto2(empleadoReporte?.email, fotophotoEmReporte);

			const empleadoAmbiental: EmpleadoViewModel = this.employees.find(
				(f) => f.id == this.centro.introductorAmbientalID,
			);
			this.introductorAmbientalControl.setValue(empleadoAmbiental);
			ruta = this.getPhoto2(
				empleadoAmbiental?.email,
				fotophotoEmAmbiental,
			);

			const empleadoSocial: EmpleadoViewModel = this.employees.find(
				(f) => f.id == this.centro.introductorSocialID,
			);
			this.introductorSocialControl.setValue(empleadoSocial);
			ruta = this.getPhoto2(empleadoSocial?.email, fotophotoEmSocial);

			const empleadoValPrincipal: EmpleadoViewModel = this.employees.find(
				(f) => f.id == this.centro.validadorPrincipalID,
			);
			this.validadorPrincipalControl.setValue(empleadoValPrincipal);
			ruta = this.getPhoto2(
				empleadoValPrincipal?.email,
				fotophotoEmValPrincipal,
			);

			const empleadoValApoyo: EmpleadoViewModel = this.employees.find(
				(f) => f.id == this.centro.validadorApoyoID,
			);
			this.validadorApoyoControl.setValue(empleadoValApoyo);
			ruta = this.getPhoto2(empleadoValApoyo?.email, fotophotoEmValApoyo);

			this.reportFormStatus();
		}
	}

	loadCebesCentro(): void {
		//if (!this.isCreating) {
		//let cebesCentro: CebeProcedureViewModel = this.cebesCentros.find(f => f.id == this.cebeCentro?.cebeID);
		this.cebeControl.setValue(this.cebesSimples[0]?.id);
		//}
	}

	backTab() {
		this.formChanged(0);
	}

	forwardTab() {
		this.formChanged(1);
	}

	detailsFormStatus(status: boolean) {
		this.responsableControl.valueChanges.forEach((value) => {
			if (status && value.id) {
				this.validatedCentroDetailsForm = true;
			} else if (!value) {
				this.validatedCentroDetailsForm = false;
			} else {
				this.validatedCentroDetailsForm = status;
			}
		});
	}

	detailsFormValue(value: FormGroup) {
		this.centroDetailData = value;
	}

	reportFormStatus() {
		let countFilled = 0;

		if (this.responsableReporteControl.value?.id) {
			countFilled++;
		}
		if (this.introductorAmbientalControl.value?.id) {
			countFilled++;
		}
		if (this.introductorSocialControl.value?.id) {
			countFilled++;
		}
		if (this.validadorPrincipalControl.value?.id) {
			countFilled++;
		}
		if (this.validadorApoyoControl.value?.id) {
			countFilled++;
		}

		if (countFilled !== 0 && countFilled === 5) {
			this.validatedUsuariosReportForm = true;
		} else {
			this.validatedUsuariosReportForm = false;
		}
	}

	designFormStatus(status: boolean) {
		this.validatedDesignForm = status;
	}

	designFormValues(value: FormGroup) {
		this.centroDesignData = value;
	}

	operationFormStatus(status: boolean) {
		this.validatedOperationForm = status;
	}

	operationFormValues(value: FormGroup) {
		this.centroOperationData = value;
	}

	submitForm(): Observable<boolean> {
		if (
			this.mainFormGroup.valid &&
			this.centroOperationData.valid &&
			this.centroDetailData.valid &&
			this.centroDesignData.valid
		) {
			let formData = this.mapFormValuesToModel(this.mainFormGroup.value);
			if (this.centro.id) {
				this._centrosService
					.updateCentro(formData, this.centro.id)
					.subscribe((result) => {
						if (result) {
							this.centro = result;
							this.ngOnInit();
						}
					});
				this._notificationService.showSuccess(
					this._translateService.instant(
						"messages.savedSuccessfully",
					),
					null,
				);
				return of(true);
			} else {
				this.mainFormGroup.get("id").setValue(0);
				this.mainFormGroup.get("edicionCentro").setValue(true);
				this.mainFormGroup.get("validacionCentro").setValue(false);

				formData = this.mapFormValuesToModel(this.mainFormGroup.value);

				this._centrosService
					.createCentro(formData)
					.subscribe((result) => {
						if (result) {
							this.centro = result;
							// this.ngOnInit();
							this.redirigirDetalle(this.centro.id);
						}
					});

				this._notificationService.showSuccess(
					this._translateService.instant(
						"messages.createdSuccessfully",
					),
					null,
				);

				return of(true);
			}
		} else {
			this.markFormGroupAsTouched(this.mainFormGroup);

			this._notificationService.showError(
				this._translateService.instant("messages.errorsWhileSaving"),
			);

			return of(false);
		}
	}

	redirigirDetalle(centroId: number): void {
		this.router.navigate(["/centro/", centroId]);
	}

	formChanged(direction: number) {
		const currentTabIndex = this.tabGroup?.selectedIndex;
		this.lastTabIndex = this.tabGroup?._tabs.length - 1;

		if (direction === 0) {
			this.navigateToBackTab(currentTabIndex);
		} else {
			this.navigateToNextTab(currentTabIndex);
		}
	}

	saveonly() {
		this.submitForm().subscribe((success) => {
			if (success) {
			}
		});
	}

	displayFn(empleado?: EmpleadoViewModel): string | undefined {
		return empleado ? empleado.nombre : undefined;
	}

	onOptionSelectedResponsable(event) {
		const empleado = event.option.value;
		this.centroDetailsComponent.nombreInput.nativeElement.value =
			empleado.nombre;
		this.getPhoto(
			empleado.email,
			this.centroDetailsComponent.photoEmResponsable,
		);
	}

	onOptionSelectedReporte(event) {
		const empleado = event.option.value;
		this.centroUserReportComponent.nombreReporteInput.nativeElement.value =
			empleado.nombre;
		this.getPhoto(
			empleado.email,
			this.centroUserReportComponent.photoEmReporte,
		);

		this.reportFormStatus();
	}

	onOptionSelectedAmbiental(event) {
		const empleado = event.option.value;
		this.centroUserReportComponent.nombreAmbientalInput.nativeElement.value =
			empleado.nombre;
		this.getPhoto(
			empleado.email,
			this.centroUserReportComponent.photoEmAmbiental,
		);

		this.reportFormStatus();
	}

	onOptionSelectedSocial(event) {
		const empleado = event.option.value;
		this.centroUserReportComponent.nombreSocialInput.nativeElement.value =
			empleado.nombre;
		this.getPhoto(
			empleado.email,
			this.centroUserReportComponent.photoEmSocial,
		);

		this.reportFormStatus();
	}

	onChangeUsersAutocomplete(event) {
		if (event.srcElement.value === "") {
			this.validatedUsuariosReportForm = false;
		}
	}

	onOptionSelectedValPrincipal(event) {
		const empleado = event.option.value;
		this.centroUserReportComponent.nombreValPrincipalInput.nativeElement.value =
			empleado.nombre;
		this.getPhoto(
			empleado.email,
			this.centroUserReportComponent.photoEmValPrincipal,
		);

		this.reportFormStatus();
	}

	onOptionSelectedValApoyo(event) {
		const empleado = event.option.value;
		this.centroUserReportComponent.nombreValSupportInput.nativeElement.value =
			empleado.nombre;
		this.getPhoto(
			empleado.email,
			this.centroUserReportComponent.photoEmValApoyo,
		);

		this.reportFormStatus();
	}

	onUploadUserDataFiles(): void {
		this.fileInput.nativeElement.click();
	}

	onFileUsersChange(event: any): void {
		const files: FileList = event.target.files;

		if (files && files.length > 0) {
			this.selectedFilesUsers = files.item(0);
			this.uploadFiles();
		}
	}

	uploadFiles(): void {
		if (this.selectedFilesUsers) {
			this._importService.uploadUsers(this.selectedFilesUsers).subscribe(
				(response: string) => {
					const blob = new Blob([response], { type: "text/plain" });
					const url = window.URL.createObjectURL(blob);
					const a = document.createElement("a");
					a.href = url;
					a.download = `resultadoCarga_${this.selectedFilesUsers.name}.txt`;
					document.body.appendChild(a);
					a.click();
					document.body.removeChild(a);
					window.URL.revokeObjectURL(url);
				},
				(error) => {
					console.error("Error uploading users:", error);
				},
			);
		}
	}

	public getUserLocale(): string {
		let locale: string = "en-US";
		const userProfile = this.userProfileStore.getUserProfile();
		if (userProfile && userProfile.preferredLang) {
			if (userProfile.preferredLang == "es") {
				locale = "es-ES";
			} else if (userProfile.preferredLang == "pl") {
				locale = "pl-PL";
			}
		}
		return locale;
	}

	public getPhoto(email: string, targetVariable: ElementRef) {
		targetVariable.nativeElement.src = "/assets/images/user.png";
		if (email) {
			this._authService.getUserPhoto(email).subscribe(
				(photoResult) => {
					const reader = new FileReader();
					reader.addEventListener(
						"load",
						() => {
							if (reader && reader.result) {
								targetVariable.nativeElement.src =
									reader.result;
							} else {
								targetVariable.nativeElement.src =
									"/assets/images/user.png";
							}
						},
						false,
					);

					if (photoResult) {
						reader.readAsDataURL(photoResult);
					}
				},
				(error) => {
					targetVariable.nativeElement.src =
						"/assets/images/user.png";
				},
			);
		}
	}

	public getPhoto2(
		email: string,
		result: string | ArrayBuffer,
	): string | ArrayBuffer {
		let photo: string | ArrayBuffer; //= "/assets/images/user.png";
		this._authService.getUserPhoto(email).subscribe(
			(photoResult) => {
				const reader = new FileReader();
				reader.addEventListener(
					"load",
					() => {
						if (reader && reader.result) {
							result = reader.result;
						} else {
							result = "/assets/images/user.png";
						}
					},
					false,
				);

				if (photoResult) {
					reader.readAsDataURL(photoResult);
				}
			},
			(error) => {
				result = "/assets/images/user.png";
			},
		);
		return photo;
	}

	// Private methods
	private markFormGroupAsTouched(formGroup: FormGroup): void {
		Object.values(formGroup.controls).forEach((control) => {
			if (control instanceof FormControl) {
				control.markAsTouched();
			} else if (control instanceof FormGroup) {
				this.markFormGroupAsTouched(control);
			}
		});
	}

	private toggleVisibilityInDiseno(
		selector: string,
		className: string,
		add: boolean,
	): void {
		if (this.centroDesignDataComponent) {
			const elements =
				this.centroDesignDataComponent.el.nativeElement.querySelectorAll(
					selector,
				);
			elements.forEach((element: HTMLElement) => {
				if (add) {
					this.renderer.addClass(element, className);
				} else {
					this.renderer.removeClass(element, className);
				}
			});
		}
	}

	private toggleVisibilityInOperacion(
		selector: string,
		className: string,
		add: boolean,
	): void {
		if (this.centroOperationDataComponent) {
			const elements =
				this.centroOperationDataComponent.el.nativeElement.querySelectorAll(
					selector,
				);
			elements.forEach((element: HTMLElement) => {
				if (add) {
					this.renderer.addClass(element, className);
				} else {
					this.renderer.removeClass(element, className);
				}
			});
		}
	}

	showHideInstallationFields(): void {
		const installationTypeId =
			this.centroDetailData.get("tipoInstalacionID");

		const selectedInstall =
			this.centroDetailsComponent.tipoInstalacionList.filter(
				(i) => i.id == installationTypeId.value,
			);

		this.hideAllOperacionDisenoFields();

		if (selectedInstall && selectedInstall.length !== 0) {
			const actividadID = selectedInstall[0].actividadID;
			const tipoProyectoID = selectedInstall[0].tipoProyectoID;
			const instalacionID = selectedInstall[0].id;

			let alcanceProyecto,
				caudalDiseno,
				numAbonados,
				kmRedAbas,
				kmRedSanea,
				habitantesEquivalentes;
			let consumoEnergeticoAnual,
				consumoEnergeticoAutoproducido,
				bonifPenalEnergetica,
				desnitrificacion,
				digestAnaerobea,
				recuperacionFosforo,
				iLI,
				prodAgua,
				volAguaDist,
				volCaudalRecog,
				usoPriPorc,
				usoPriAguaProd,
				usoSecPorc,
				usoSecAguaProd,
				usoPriPorcRege,
				usoPriAguaRege,
				poblaAbaste;

			alcanceProyecto =
				caudalDiseno =
				numAbonados =
				iLI =
				kmRedAbas =
				kmRedSanea =
				habitantesEquivalentes =
					false;
			consumoEnergeticoAnual =
				consumoEnergeticoAutoproducido =
				bonifPenalEnergetica =
				desnitrificacion =
				digestAnaerobea =
				recuperacionFosforo =
				prodAgua =
				volAguaDist =
				volCaudalRecog =
				usoPriPorc =
				usoPriAguaProd =
				usoSecPorc =
				usoSecAguaProd =
				usoPriPorcRege =
				usoPriAguaRege =
				poblaAbaste =
					false;

			switch (actividadID) {
				case 1: // Diseño y Construcción
					if (tipoProyectoID === 9 && instalacionID === 17) {
						// EBAR EBAR
						alcanceProyecto =
							caudalDiseno =
							habitantesEquivalentes =
								true;
						consumoEnergeticoAnual =
							consumoEnergeticoAutoproducido =
							bonifPenalEnergetica =
								true;
					}
					if (tipoProyectoID === 7 && instalacionID === 14) {
						// EDAR EDAR
						alcanceProyecto =
							caudalDiseno =
							habitantesEquivalentes =
								true;
						consumoEnergeticoAnual =
							consumoEnergeticoAutoproducido =
							bonifPenalEnergetica =
							desnitrificacion =
							digestAnaerobea =
							recuperacionFosforo =
							usoPriPorcRege =
							usoPriAguaRege =
								true;
					}
					if (tipoProyectoID === 8 && instalacionID === 32) {
						// ETAP ETAP
						alcanceProyecto = caudalDiseno = true;
						consumoEnergeticoAnual =
							consumoEnergeticoAutoproducido =
							bonifPenalEnergetica =
							usoPriPorc =
							usoPriAguaProd =
							usoSecPorc =
							usoSecAguaProd =
							poblaAbaste =
								true;
					}
					if (tipoProyectoID === 11 && instalacionID === 33) {
						// IDAM IDAM
						alcanceProyecto = caudalDiseno = true;
						consumoEnergeticoAnual =
							consumoEnergeticoAutoproducido =
							bonifPenalEnergetica =
							usoPriPorc =
							usoPriAguaProd =
							usoSecPorc =
							usoSecAguaProd =
							poblaAbaste =
								true;
					}
					if (
						tipoProyectoID === 10 &&
						(instalacionID === 18 || instalacionID === 56)
					) {
						// REDI REDI
						alcanceProyecto =
							caudalDiseno =
							habitantesEquivalentes =
								true;
						consumoEnergeticoAnual =
							consumoEnergeticoAutoproducido =
							bonifPenalEnergetica =
							iLI =
								true;
					}
					break;
				case 2: // Operación y Mantenimiento
					if (tipoProyectoID === 6 && instalacionID === 13) {
						// IDAM IDAM
						caudalDiseno = true;
						consumoEnergeticoAnual =
							consumoEnergeticoAutoproducido =
							bonifPenalEnergetica =
							usoPriPorc =
							usoPriAguaProd =
							usoSecPorc =
							usoSecAguaProd =
							poblaAbaste =
								true;
					}
					if (
						tipoProyectoID === 5 &&
						(instalacionID === 12 || instalacionID === 31)
					) {
						// ETAP ETAP
						caudalDiseno = true;
						consumoEnergeticoAnual =
							consumoEnergeticoAutoproducido =
							bonifPenalEnergetica =
							usoPriPorc =
							usoPriAguaProd =
							usoSecPorc =
							usoSecAguaProd =
							poblaAbaste =
								true;
					}
					if (
						tipoProyectoID === 4 &&
						(instalacionID === 10 || instalacionID === 29)
					) {
						// EDAR EDAR
						caudalDiseno = habitantesEquivalentes = true;
						consumoEnergeticoAnual =
							consumoEnergeticoAutoproducido =
							bonifPenalEnergetica =
							desnitrificacion =
							digestAnaerobea =
							recuperacionFosforo =
							prodAgua =
							usoPriPorcRege =
							usoPriAguaRege =
								true;
					}
					if (
						tipoProyectoID === 16 &&
						(instalacionID === 63 ||
							instalacionID === 64 ||
							instalacionID === 65)
					) {
						// REDI REDI
						alcanceProyecto =
							caudalDiseno =
							habitantesEquivalentes =
								true;
						consumoEnergeticoAnual =
							consumoEnergeticoAutoproducido =
							bonifPenalEnergetica =
							iLI =
								true;
					}
					break;
				case 3: // Servicios
					if (
						tipoProyectoID === 3 &&
						(instalacionID === 8 || instalacionID === 27)
					) {
						// SRAB OSER
						numAbonados = kmRedAbas = true;
						consumoEnergeticoAnual =
							consumoEnergeticoAutoproducido =
							bonifPenalEnergetica =
							volAguaDist =
							iLI =
								true;
					}
					if (
						tipoProyectoID === 3 &&
						(instalacionID === 9 || instalacionID === 28)
					) {
						// SRAB ETAP
						caudalDiseno = true;
						consumoEnergeticoAnual =
							consumoEnergeticoAutoproducido =
							bonifPenalEnergetica =
							usoPriPorc =
							usoPriAguaProd =
							usoSecAguaProd =
							usoSecPorc =
							poblaAbaste =
								true;
					}
					// if (tipoProyectoID === 3 && instalacionID === 13) {
					//   // SRED EDAR
					//   habitantesEquivalentes = caudalDiseno = true;
					//   consumoEnergeticoAnual =
					//     consumoEnergeticoAutoproducido =
					//     bonifPenalEnergetica =
					//     desnitrificacion =
					//     digestAnaerobea =
					//     recuperacionFosforo =
					//     prodAgua =
					//     volCaudalRecog =
					//       true;
					// }
					if (
						tipoProyectoID === 2 &&
						(instalacionID === 4 || instalacionID === 23)
					) {
						// SRIN OSER
						numAbonados =
							kmRedAbas =
							kmRedSanea =
							habitantesEquivalentes =
								true;
						consumoEnergeticoAnual =
							consumoEnergeticoAutoproducido =
							bonifPenalEnergetica =
							volAguaDist =
							volCaudalRecog =
							iLI =
								true;
					}
					if (
						tipoProyectoID === 2 &&
						(instalacionID === 5 || instalacionID === 24)
					) {
						// SRIN EDAR
						caudalDiseno = habitantesEquivalentes = true;
						consumoEnergeticoAnual =
							consumoEnergeticoAutoproducido =
							bonifPenalEnergetica =
							desnitrificacion =
							digestAnaerobea =
							recuperacionFosforo =
							prodAgua =
							usoPriPorcRege =
							usoPriAguaRege =
								true;
					}
					if (
						tipoProyectoID === 2 &&
						(instalacionID === 7 || instalacionID === 26)
					) {
						// SRIN EBAR
						caudalDiseno = habitantesEquivalentes = true;
						consumoEnergeticoAnual =
							consumoEnergeticoAutoproducido =
							bonifPenalEnergetica =
								true;
					}
					if (
						tipoProyectoID === 2 &&
						(instalacionID === 6 || instalacionID === 25)
					) {
						// SRIN ETAP
						caudalDiseno = true;
						consumoEnergeticoAnual =
							consumoEnergeticoAutoproducido =
							bonifPenalEnergetica =
							usoPriPorc =
							usoPriAguaProd =
							usoSecPorc =
							usoSecAguaProd =
							poblaAbaste =
								true;
					}
					if (
						tipoProyectoID === 1 &&
						(instalacionID === 1 || instalacionID === 20)
					) {
						// SRSA OSER
						habitantesEquivalentes = kmRedSanea = true;
						consumoEnergeticoAnual =
							consumoEnergeticoAutoproducido =
							bonifPenalEnergetica =
							volCaudalRecog =
								true;
					}
					if (
						tipoProyectoID === 1 &&
						(instalacionID === 3 || instalacionID === 22)
					) {
						// SRSA EBAR
						caudalDiseno = habitantesEquivalentes = true;
						consumoEnergeticoAnual =
							consumoEnergeticoAutoproducido =
							bonifPenalEnergetica =
								true;
					}
					if (
						tipoProyectoID === 1 &&
						(instalacionID === 2 || instalacionID === 21)
					) {
						// SRSA EDAR
						caudalDiseno = habitantesEquivalentes = true;
						consumoEnergeticoAnual =
							consumoEnergeticoAutoproducido =
							bonifPenalEnergetica =
							desnitrificacion =
							digestAnaerobea =
							recuperacionFosforo =
							prodAgua =
							usoPriPorcRege =
							usoPriAguaRege =
								true;
					}
					if (
						tipoProyectoID === 14 &&
						(instalacionID === 36 || instalacionID === 37)
					) {
						// SRET ETAP
						caudalDiseno = true;
						consumoEnergeticoAnual =
							consumoEnergeticoAutoproducido =
							bonifPenalEnergetica =
							usoPriPorc =
							usoPriAguaProd =
							usoSecPorc =
							usoSecAguaProd =
							poblaAbaste =
								true;
					}
					if (
						tipoProyectoID === 13 &&
						(instalacionID === 34 || instalacionID === 35)
					) {
						// SRED EDAR
						caudalDiseno = habitantesEquivalentes = true;
						consumoEnergeticoAnual =
							consumoEnergeticoAutoproducido =
							bonifPenalEnergetica =
							desnitrificacion =
							digestAnaerobea =
							recuperacionFosforo =
							prodAgua =
							usoPriPorcRege =
							usoPriAguaRege =
								true;
					}
					break;
				default:
			}

			this.showHideOperacionDisenoFields(
				alcanceProyecto,
				caudalDiseno,
				numAbonados,
				iLI,
				kmRedAbas,
				kmRedSanea,
				habitantesEquivalentes,
				consumoEnergeticoAnual,
				consumoEnergeticoAutoproducido,
				bonifPenalEnergetica,
				desnitrificacion,
				digestAnaerobea,
				recuperacionFosforo,
				prodAgua,
				volAguaDist,
				volCaudalRecog,
				usoPriPorc,
				usoPriAguaProd,
				usoSecPorc,
				usoSecAguaProd,
				usoPriPorcRege,
				usoPriAguaRege,
				poblaAbaste,
			);
		} else {
			this.toggleVisibilityInDiseno(".instDatosDiseno", "hidden", true);
			this.toggleVisibilityInOperacion(
				".instDatosOperacion",
				"hidden",
				true,
			);
		}
	}

	initFieldsAndActivitySelector(): void {
		this.showHideInstallationFields();
	}

	showHideOperacionDisenoFields(
		alcanceProyecto: any,
		caudalDiseno: any,
		numAbonados: any,
		iLI: any,
		kmRedAbas: any,
		kmRedSanea: any,
		habitantesEquivalentes: any,
		consEnergeticoAnual: any,
		consEnergeticoAutoproducido: any,
		bonificacionPenalizacionEnergetica: any,
		desnitrificacion: any,
		digestionAnaerobea: any,
		recuperacionFosforo: any,
		produccionAgua: any,
		volumenAguaDistribuida: any,
		volumenCaudalRecogido: any,
		usoPorcentajePpalProd: any,
		usoPrimarioAguaProd: any,
		usoPorcentajeSecundario: any,
		usoSecundarioAguaProd: any,
		usoPorcentajePpalRege: any,
		usoPrimarioAguaRege: any,
		poblacionAbastecida: any,
	): void {
		const showDiseno =
			alcanceProyecto ||
			caudalDiseno ||
			numAbonados ||
			kmRedAbas ||
			kmRedSanea ||
			habitantesEquivalentes;
		this.toggleVisibilityInDiseno(
			".instDatosDiseno",
			"hidden",
			!showDiseno,
		);

		const showOperacion =
			consEnergeticoAnual ||
			consEnergeticoAutoproducido ||
			bonificacionPenalizacionEnergetica ||
			desnitrificacion ||
			digestionAnaerobea ||
			recuperacionFosforo ||
			produccionAgua ||
			volumenAguaDistribuida ||
			volumenCaudalRecogido ||
			iLI ||
			usoPorcentajePpalProd ||
			usoPrimarioAguaProd ||
			usoPorcentajeSecundario ||
			usoSecundarioAguaProd ||
			usoPorcentajePpalRege ||
			usoPrimarioAguaRege ||
			poblacionAbastecida;
		this.toggleVisibilityInOperacion(
			".instDatosOperacion",
			"hidden",
			!showOperacion,
		);

		this.toggleVisibilityInDiseno(
			".instAlcanceProyecto",
			"hidden",
			!alcanceProyecto,
		);
		this.toggleVisibilityInDiseno(
			".instCaudalDiseno",
			"hidden",
			!caudalDiseno,
		);
		this.toggleVisibilityInDiseno(
			".instNumAbonados",
			"hidden",
			!numAbonados,
		);
		this.toggleVisibilityInDiseno(".instKmRedAbas", "hidden", !kmRedAbas);
		this.toggleVisibilityInDiseno(".instKmRedSanea", "hidden", !kmRedSanea);
		this.toggleVisibilityInDiseno(
			".instHabitantesEquivalentes",
			"hidden",
			!habitantesEquivalentes,
		);

		this.toggleVisibilityInOperacion(".instILI", "hidden", !iLI);
		this.toggleVisibilityInOperacion(
			".instConsumoEnergeticoAnual",
			"hidden",
			!consEnergeticoAnual,
		);
		this.toggleVisibilityInOperacion(
			".instConsumoEnergeticoAutoproducido",
			"hidden",
			!consEnergeticoAutoproducido,
		);
		this.toggleVisibilityInOperacion(
			".instBonificacionPenalizacionEnergetica",
			"hidden",
			!bonificacionPenalizacionEnergetica,
		);
		this.toggleVisibilityInOperacion(
			".instDesnitrificacion",
			"hidden",
			!desnitrificacion,
		);
		this.toggleVisibilityInOperacion(
			".instDigestionAnaerobia",
			"hidden",
			!digestionAnaerobea,
		);
		this.toggleVisibilityInOperacion(
			".instRecuperacionFosforo",
			"hidden",
			!recuperacionFosforo,
		);
		this.toggleVisibilityInOperacion(
			".instProduccionAgua",
			"hidden",
			!produccionAgua,
		);
		this.toggleVisibilityInOperacion(
			".instVolumenAguaDistribuida",
			"hidden",
			!volumenAguaDistribuida,
		);
		this.toggleVisibilityInOperacion(
			".instVolumenCaudalRecogido",
			"hidden",
			!volumenCaudalRecogido,
		);
		this.toggleVisibilityInOperacion(
			".instUsoPorcentajePpalProd",
			"hidden",
			!usoPorcentajePpalProd,
		);
		this.toggleVisibilityInOperacion(
			".instUsoPrincipalAguaProd",
			"hidden",
			!usoPrimarioAguaProd,
		);
		this.toggleVisibilityInOperacion(
			".instUsoPorcentajeSecundario",
			"hidden",
			!usoPorcentajeSecundario,
		);
		this.toggleVisibilityInOperacion(
			".instUsoSecundarioAguaProd",
			"hidden",
			!usoSecundarioAguaProd,
		);
		this.toggleVisibilityInOperacion(
			".instUsoPorcentajePpalRege",
			"hidden",
			!usoPorcentajePpalRege,
		);
		this.toggleVisibilityInOperacion(
			".instUsoPrincipalAguaRege",
			"hidden",
			!usoPrimarioAguaRege,
		);
		this.toggleVisibilityInOperacion(
			".instPoblacionAbastecida",
			"hidden",
			!poblacionAbastecida,
		);
	}

	hideAllOperacionDisenoFields(): void {
		this.toggleVisibilityInDiseno(".instAlcanceProyecto", "hidden", true);
		this.toggleVisibilityInDiseno(".instCaudalDiseno", "hidden", true);
		this.toggleVisibilityInDiseno(".instNumAbonados", "hidden", true);
		this.toggleVisibilityInDiseno(".instILI", "hidden", true);
		this.toggleVisibilityInDiseno(".instKmRedAbas", "hidden", true);
		this.toggleVisibilityInDiseno(
			".instHabitantesEquivalentes",
			"hidden",
			true,
		);

		this.toggleVisibilityInOperacion(
			".instConsumoEnergeticoAnual",
			"hidden",
			true,
		);
		this.toggleVisibilityInOperacion(
			".instConsumoEnergeticoAutoproducido",
			"hidden",
			true,
		);
		this.toggleVisibilityInOperacion(
			".instBonificacionPenalizacionEnergetica",
			"hidden",
			true,
		);
		this.toggleVisibilityInOperacion(
			".instDesnitrificacion",
			"hidden",
			true,
		);
		this.toggleVisibilityInOperacion(
			".instDigestionAnaerobia",
			"hidden",
			true,
		);
		this.toggleVisibilityInOperacion(
			".instRecuperacionFosforo",
			"hidden",
			true,
		);
		this.toggleVisibilityInOperacion(".instProduccionAgua", "hidden", true);
		this.toggleVisibilityInOperacion(
			".instVolumenAguaDistribuida",
			"hidden",
			true,
		);
		this.toggleVisibilityInOperacion(
			".instVolumenCaudalRecogido",
			"hidden",
			true,
		);
		this.toggleVisibilityInOperacion(
			".instUsoPorcentajePpalProd",
			"hidden",
			true,
		);
		this.toggleVisibilityInOperacion(
			".instUsoPrincipalAguaProd",
			"hidden",
			true,
		);
		this.toggleVisibilityInOperacion(
			".instUsoPorcentajeSecundario",
			"hidden",
			true,
		);
		this.toggleVisibilityInOperacion(
			".instUsoSecundarioAguaProd",
			"hidden",
			true,
		);
		this.toggleVisibilityInOperacion(
			".instUsoPorcentajePpalRege",
			"hidden",
			true,
		);
		this.toggleVisibilityInOperacion(
			".instUsoPrincipalAguaRege",
			"hidden",
			true,
		);
		this.toggleVisibilityInOperacion(
			".instPoblacionAbastecida",
			"hidden",
			true,
		);
	}

	private navigateToNextTab(currentTabIndex: number | undefined): void {
		if (
			currentTabIndex !== undefined &&
			currentTabIndex < this.tabGroup?._tabs.length - 1
		) {
			this.tabGroup.selectedIndex = currentTabIndex + 1;
		} else {
			this.router.navigate(["/home"]);
		}
	}

	private navigateToBackTab(currentTabIndex: number | undefined): void {
		if (currentTabIndex !== undefined && currentTabIndex == 0) {
			this.router.navigate([`/cebes/detail/${this.cebesimple.id}`]);
		} else {
			this.tabGroup.selectedIndex = currentTabIndex - 1;
		}
	}

	private _filterEmResponsable(
		value: string | EmpleadoViewModel,
	): EmpleadoViewModel[] {
		const filterValue =
			typeof value === "string" ? value.toLowerCase() : "";
		return this.employees.filter((option) =>
			option.nombre.toLowerCase().includes(filterValue),
		);
	}

	private _filterEmReporte(
		value: string | EmpleadoViewModel,
	): EmpleadoViewModel[] {
		const filterValue =
			typeof value === "string" ? value.toLowerCase() : "";
		return this.employees.filter((option) =>
			option.nombre.toLowerCase().includes(filterValue),
		);
	}

	private _filterEmAmbiental(
		value: string | EmpleadoViewModel,
	): EmpleadoViewModel[] {
		const filterValue =
			typeof value === "string" ? value.toLowerCase() : "";
		return this.employees.filter((option) =>
			option.nombre.toLowerCase().includes(filterValue),
		);
	}

	private _filterEmSocial(
		value: string | EmpleadoViewModel,
	): EmpleadoViewModel[] {
		const filterValue =
			typeof value === "string" ? value.toLowerCase() : "";
		return this.employees.filter((option) =>
			option.nombre.toLowerCase().includes(filterValue),
		);
	}

	private _filterValPrincipal(
		value: string | EmpleadoViewModel,
	): EmpleadoViewModel[] {
		const filterValue =
			typeof value === "string" ? value.toLowerCase() : "";
		return this.employees.filter((option) =>
			option.nombre.toLowerCase().includes(filterValue),
		);
	}

	private _filterValApoyo(
		value: string | EmpleadoViewModel,
	): EmpleadoViewModel[] {
		const filterValue =
			typeof value === "string" ? value.toLowerCase() : "";
		return this.employees.filter((option) =>
			option.nombre.toLowerCase().includes(filterValue),
		);
	}

	private initCreateMode() {
		this.centro = {} as CentrosViewModel;
		this.mainFormGroup = this.initMainFormGroup();
	}

	private mapFormValuesToModel(formValues: any): CentrosViewModel {
		const contratosCentrosDropDownListSelected: number[] = [];
		if (this.cebeControl.value !== undefined) {
			contratosCentrosDropDownListSelected.push(this.cebeControl.value);
		}

		const result: CentrosViewModel = {
			id: formValues.id,
			codigo: formValues.codigo,
			edicionCentro: formValues.edicionCentro,
			validacionCentro: formValues.validacionCentro,
			responsableID: this.responsableControl.value?.id,

			descripcion: this.centroDetailData?.get("descripcion")?.value,
			activo: this.centroDetailData?.get("activo")?.value,
			localizacionID: this.centroDetailData?.get("localizacionID")?.value,
			ciudad: this.centroDetailData?.get("ciudad")?.value,
			latitud: this.centroDetailData?.get("latitud")?.value,
			longitud: this.centroDetailData?.get("longitud")?.value,
			tipoInstalacionID:
				this.centroDetailData?.get("tipoInstalacionID")?.value,
			centroActividadID:
				this.centroDetailData?.get("centroActividadID")?.value,
			imageDataB64: this.centroDetailData?.get("imageDataB64")?.value,

			responsableReporteID: this.responsableReporteControl.value?.id,
			introductorAmbientalID: this.introductorAmbientalControl.value?.id,
			introductorSocialID: this.introductorSocialControl.value?.id,
			validadorPrincipalID: this.validadorPrincipalControl.value?.id,
			validadorApoyoID: this.validadorApoyoControl.value?.id,

			alcancePryID: this.centroDesignData?.get("alcancePryID")?.value,
			caudalDiseno: this.centroDesignData?.get("caudalDiseno")?.value,
			habitantesEquivalentes: this.centroDesignData?.get(
				"habitantesEquivalentes",
			)?.value,
			numeroAbonados: this.centroDesignData?.get("numeroAbonados")?.value,
			kmRedAbas: this.centroDesignData?.get("kmRedAbas")?.value,
			kmRedSanea: this.centroDesignData?.get("kmRedSanea")?.value,

			cecoaCentro: this.centroOperationData?.get("cecoaCentro")?.value,
			digestionAnaerobiaFangoID: this.centroOperationData?.get(
				"digestionAnaerobiaFangoID",
			)?.value,
			primaIncluidaID:
				this.centroOperationData?.get("primaIncluidaID")?.value,
			conEnerAn: this.centroOperationData?.get("conEnerAn")?.value,
			conEnerAnAut: this.centroOperationData?.get("conEnerAnAut")?.value,
			producAgua: this.centroOperationData?.get("producAgua")?.value,
			recupFosforoID:
				this.centroOperationData?.get("recupFosforoID")?.value,
			voluRecoSan: this.centroOperationData?.get("voluRecoSan")?.value,
			usoPriPorc: this.centroOperationData?.get("usoPriPorc")?.value,
			usoPriAguaProdID:
				this.centroOperationData?.get("usoPriAguaProdID")?.value,
			usoPriPorcRege:
				this.centroOperationData?.get("usoPriPorcRege")?.value,
			usoPriAguaRegeID:
				this.centroOperationData?.get("usoPriAguaRegeID")?.value,
			usoSecPorc: this.centroOperationData?.get("usoSecPorc")?.value,
			usoSecAguaProdID:
				this.centroOperationData?.get("usoSecAguaProdID")?.value,
			poblaAbaste: this.centroOperationData?.get("poblaAbaste")?.value,
			introductorGeneralID: this.centroOperationData?.get(
				"introductorGeneralID",
			)?.value,
			desnitrificacionID:
				this.centroOperationData?.get("desnitrificacionID")?.value,
			iLI: this.centroOperationData?.get("iLI")?.value,
			volumenFacturado:
				this.centroOperationData?.get("volumenFacturado")?.value,

			fechaValidacion: formValues.centroUserReport.fechaValidacion,
			fechaListoMigra: this.centro?.fechaListoMigra,
			fechaModificacion: this.centro?.fechaModificacion,

			contratosCentrosDropDownListSelected,
		};
		return result;
	}

	initMainFormGroup(): FormGroup {
		return this.fb.group({
			id: [this.centro?.id],
			codigo: [this.centro?.codigo],
			edicionCentro: [this.centro?.edicionCentro],
			validacionCentro: [this.centro?.validacionCentro],
			centroDetails: this.fb.group({
				cebe: this.cebeControl,
				responsable: this.responsableControl,
			}),
			centroUserReport: this.fb.group({
				responsableReporte: this.responsableReporteControl,
				introductorAmbiental: this.introductorAmbientalControl,
				introductorSocial: this.introductorSocialControl,
				validadorPrincipal: this.validadorPrincipalControl,
				validadorApoyo: this.validadorApoyoControl,
				fechaValidacion: [this.centro?.fechaValidacion],
			}),
		});
	}
}
